module.exports = __webpack_public_path__ + "static/img/c4.a45c7404.png";